export const LIVE_EXPERIENCE_NOT_SHOW_SETTING_CASE_TABS = [
    {
        pageId: 0,
        icon: '',
        hoverName: 'Experience Picker',
        stepKey: ['path', 'content']
    },
    {
        pageId: 1,
        icon: '',
        hoverName: 'Ways to invite participants',
        stepKey: ['moderatedInviteWay']
    },
    {
        pageId: 2,
        icon: '',
        hoverName: 'Name/Date adjustment',
        stepKey: ['moderatedName', 'moderatedStartDate', 'moderatedEndDate']
    },
    {
        pageId: 4,
        icon: '',
        hoverName: 'Invite participants',
        stepKey: ['asyncParticipants']
    },
    {
        pageId: 5,
        icon: '',
        hoverName: 'Agenda/Schedule',
        stepKey: ['moderatedAgendaSchedules']
    },
    {
        pageId: 6,
        icon: '',
        hoverName: 'Review and Go Live',
        stepKey: ['moderatedCompleted']
    },
    {
        pageId: 7,
        icon: '',
        active: 'last_step_active.svg',
        inactive: 'last_step_inactive.svg',
        hover: 'last_step_inactive_hover.svg',
        hoverName: 'End',
        stepKey: ['x']
    },
];

export const LIVE_EXPERIENCE_SHOW_SETTING_CASE_TABS = [
    {
        pageId: 0,
        icon: '',
        hoverName: 'Experience Picker',
        stepKey: ['path', 'content']
    },
    {
        pageId: 1,
        icon: '',
        hoverName: 'Ways to invite participants',
        stepKey: ['moderatedInviteWay']
    },
    {
        pageId: 2,
        icon: '',
        hoverName: 'Name/Date adjustment',
        stepKey: ['moderatedName', 'moderatedStartDate', 'moderatedEndDate']
    },
    {
        pageId: 3,
        icon: '',
        hoverName: 'Planning',
        stepKey: ['planning']
    },
    {
        pageId: 4,
        icon: '',
        hoverName: 'Invite participants',
        stepKey: ['asyncParticipants']
    },
    {
        pageId: 5,
        icon: '',
        hoverName: 'Agenda/Schedule',
        stepKey: ['moderatedAgendaSchedules']
    },
    {
        pageId: 6,
        icon: '',
        hoverName: 'Review and Go Live',
        stepKey: ['moderatedCompleted']
    },
    {
        pageId: 7,
        icon: '',
        active: 'last_step_active.svg',
        inactive: 'last_step_inactive.svg',
        hover: 'last_step_inactive_hover.svg',
        hoverName: 'End',
        stepKey: ['x']
    },
];

export const LIVE_EXPERIENCE_CALENDAR_CASE_TABS = [
    {
        pageId: 0,
        icon: '',
        hoverName: 'Experience Picker',
        stepKey: ['path', 'content']
    },
    {
        pageId: 1,
        icon: '',
        hoverName: 'Ways to invite participants',
        stepKey: ['moderatedInviteWay']
    },
    {
        pageId: 2,
        icon: '',
        hoverName: 'Invite participants',
        stepKey: ['moderatedCalendarInviteStep'],
        active: '',
        inactive: '',
    },
];

export const LIVE_EXPERIENCE_HUB_CASE_TABS = [
    {
        pageId: 0,
        icon: '',
        hoverName: 'Experience Picker',
        stepKey: ['path', 'content']
    },
    {
        pageId: 1,
        icon: '',
        hoverName: 'Ways to invite participants',
        stepKey: ['moderatedInviteWay']
    },
    {
        pageId: 2,
        icon: '',
        hoverName: 'Name/Date adjustment',
        stepKey: ['moderatedName', 'moderatedStartDate', 'moderatedEndDate']
    },
    {
        pageId: 4,
        icon: '',
        hoverName: 'Connectivity Hub',
        stepKey: ['hubs']
    },
    {
        pageId: 5,
        icon: '',
        hoverName: 'Agenda/Schedule',
        stepKey: ['moderatedAgendaSchedules']
    },
    {
        pageId: 6,
        icon: '',
        hoverName: 'Review and Go Live',
        stepKey: ['moderatedCompleted']
    },
    {
        pageId: 7,
        icon: '',
        active: 'last_step_active.svg',
        inactive: 'last_step_inactive.svg',
        hover: 'last_step_inactive_hover.svg',
        hoverName: 'End',
        stepKey: ['x']
    },
];

export const PRE_REORDERED_NOT_SHOW_SETTING_CASE_TABS = [
    {
        pageId: 0,
        icon: '',
        hoverName: 'Experience Picker',
        stepKey: ['path', 'content']
    },
    {
        pageId: 1,
        icon: '',
        hoverName: 'Add video',
        stepKey: ['asyncVideoUrl', 'asyncExperienceName']
    },
    {
        pageId: 2,
        icon: '',
        hoverName: 'Date adjustment',
        stepKey: ['asyncStartDate']
    },
    {
        pageId: 4,
        icon: '',
        hoverName: 'Add Participants',
        stepKey: ['asyncParticipants']
    },
    {
        pageId: 5,
        icon: '',
        hoverName: 'Review and Go Live',
        stepKey: ['asyncCompleted']
    },
    {
        pageId: 6,
        icon: '',
        active: 'last_step_active.svg',
        inactive: 'last_step_inactive.svg',
        hover: 'last_step_inactive_hover.svg',
        hoverName: 'End',
        stepKey: ['dwq']
    },
];

export const PRE_REORDERED_SHOW_SETTING_CASE_TABS = [
    {
        pageId: 0,
        icon: '',
        hoverName: 'Experience Picker',
        stepKey: ['path', 'content']
    },
    {
        pageId: 1,
        icon: '',
        hoverName: 'Add video',
        stepKey: ['asyncVideoUrl', 'asyncExperienceName']
    },
    {
        pageId: 2,
        icon: '',
        hoverName: 'Date adjustment',
        stepKey: ['asyncStartDate']
    },
    {
        pageId: 3,
        icon: '',
        hoverName: 'Planning',
        stepKey: ['planning']
    },
    {
        pageId: 4,
        icon: '',
        hoverName: 'Add Participants',
        stepKey: ['asyncParticipants']
    },
    {
        pageId: 5,
        icon: '',
        hoverName: 'Review and Go Live',
        stepKey: ['asyncCompleted']
    },
    {
        pageId: 6,
        icon: '',
        active: 'last_step_active.svg',
        inactive: 'last_step_inactive.svg',
        hover: 'last_step_inactive_hover.svg',
        hoverName: 'End',
        stepKey: ['dwq']
    },
];

export const SIDEBAR_REELS_REORDERED = [
    {
        pageId: 0,
        icon: '',
        hoverName: 'Review Reel Sessions',
        stepKey: ['path', 'confirmsessions']
    },
    {
        pageId: 1,
        icon: '',
        hoverName: 'Reel Name',
        stepKey: ['ReelUrl', 'ReelName']
    },
    {
        pageId: 2,
        icon: '',
        hoverName: 'Date adjustment',
        stepKey: ['reelsStartDate']
    },
    {
        pageId: 3,
        icon: '',
        hoverName: 'Add Participants',
        stepKey: ['reelsParticipants']
    },
    {
        pageId: 4,
        icon: '',
        hoverName: 'Review and Go Live',
        stepKey: ['reelsCompleted']
    },
    {
        pageId: 5,
        icon: '',
        active: 'last_step_active.svg',
        inactive: 'last_step_inactive.svg',
        hover: 'last_step_inactive_hover.svg',
        hoverName: 'End',
        stepKey: ['dwq']
    },
]